var chunkMapping = {
	"46": [
		20046
	],
	"104": [
		90104
	],
	"202": [
		70202
	],
	"1049": [
		31049
	],
	"1132": [
		91132
	],
	"1987": [
		81987
	],
	"2169": [
		22169
	],
	"2211": [
		12211
	],
	"2757": [
		62757
	],
	"3116": [
		23116
	],
	"3487": [
		73487
	],
	"3920": [
		63920
	],
	"4070": [
		84070
	],
	"4382": [
		24382
	],
	"4430": [
		34430
	],
	"4659": [
		54659
	],
	"5568": [
		15568
	],
	"5659": [
		75659
	],
	"5737": [
		65737
	],
	"5763": [
		75763
	],
	"6711": [
		16711
	],
	"6779": [
		6779
	],
	"7422": [
		7422
	],
	"7998": [
		97998
	],
	"8510": [
		78510
	],
	"9045": [
		82759
	],
	"9106": [
		59106
	],
	"9123": [
		89123
	],
	"9659": [
		79659
	]
};
var idToExternalAndNameMapping = {
	"6779": [
		"default",
		"./RegulatoryBundleList",
		70958
	],
	"7422": [
		"default",
		"./NumberDemand",
		70958
	],
	"12211": [
		"default",
		"./Pages",
		45573
	],
	"15568": [
		"default",
		"./EndCustomersList",
		70958
	],
	"16711": [
		"default",
		"./RegulatoryBundleView",
		70958
	],
	"20046": [
		"default",
		"./EndCustomersAddServices",
		70958
	],
	"22169": [
		"default",
		"./OrderDetailsNew",
		70958
	],
	"23116": [
		"default",
		"./EditBundleSuccess",
		70958
	],
	"24382": [
		"default",
		"./Slices",
		45573
	],
	"31049": [
		"default",
		"./EndCustomersAdd",
		70958
	],
	"34430": [
		"default",
		"./OrderComments",
		70958
	],
	"54659": [
		"default",
		"./LandingPage",
		70958
	],
	"59106": [
		"default",
		"./CountryOverview",
		70958
	],
	"62757": [
		"default",
		"./AddBundle",
		70958
	],
	"63920": [
		"default",
		"./BundleManagementDetails",
		70958
	],
	"65737": [
		"default",
		"./OrderListNew",
		70958
	],
	"70202": [
		"default",
		"./NumberRequest",
		70958
	],
	"73487": [
		"default",
		"./RegulationsView",
		70958
	],
	"75659": [
		"default",
		"./EditEndCustomerDetails",
		70958
	],
	"75763": [
		"default",
		"./EndCustomerDetails",
		70958
	],
	"78510": [
		"default",
		"./Api",
		45573
	],
	"79659": [
		"default",
		"./BuyNumbers",
		70958
	],
	"81987": [
		"default",
		"./BundleManagementSuccess",
		70958
	],
	"82759": [
		"default",
		"./i18n",
		70958
	],
	"84070": [
		"default",
		"./NumbersList",
		70958
	],
	"89123": [
		"default",
		"./CountryManage",
		70958
	],
	"90104": [
		"default",
		"./EditBundle",
		70958
	],
	"91132": [
		"default",
		"./BundlesManagementList",
		70958
	],
	"97998": [
		"default",
		"./Provider",
		70958
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}